export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/Worker.8b9074d9.worker.js");
}
